function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M15 0C6.7 0 0 6.7 0 15s6.7 15 15 15 15-6.7 15-15S23.3 0 15 0zm0 27.8C8 27.8 2.2 22 2.2 15S8 2.2 15 2.2 27.8 8 27.8 15 22 27.8 15 27.8zm1.4-18.5c0 .8-.6 1.4-1.4 1.4-.7 0-1.4-.6-1.4-1.4s.6-1.4 1.4-1.4c.7 0 1.4.7 1.4 1.4zm-2.5 3.1h2.2v10.1h-2.2V12.4z"
})));